import api from "./api";

export const fetchClients = async () => {
  const response = await api.get("/versus/clients");
  return response;
};

export const updateClient = async (payload) => {
  const response = await api.put("/versus/clients", payload);
  return response;
};

export const fetchClient = async (clientRef) => {
  const response = await api.get("/versus/client", {
    params: {
      clientRef: clientRef,
    },
  });
  return response;
};

export const fetchCampaigns = async (params) => {
  return api.get("/versus/campaigns", {
    params,
  });
};

export const fetchCampaign = async (clientRef, campaignRef) => {
  try {
    const response = await api.get("/versus/campaign", {
      params: {
        clientRef: clientRef,
        campaignRef: campaignRef,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const fetchTotalSurveys = async (clientRef) => {
  const response = await api.get(`/versus/totalsurveys?clientRef=${clientRef}`);
  return response;
};

export const fetchCampaignStatuses = async () => {
  const response = await api.get("/enums/campaignstatuses");
  return response;
};

export const genders = async () => {
  const response = await api.get("/enums/genders");
  return response;
};

export const fetchSMEStartUpStage = async () => {
  const response = await api.get("/enums/smesetupstages");
  return response;
};

export const clientSectorsAndInterest = async () => {
  const response = await api.get("/enums/clientsectors");
  return response;
};

export const statesList = async () => {
  const response = await api.get("/enums/states");
  return response;
};

export const selectedLGAList = async () => {
  const response = await api.get("/enums/lga");
  return response;
};

export const interactTypes = async () => {
  const response = await api.get("/enums/interacttypes");
  return response;
};

export const mediaTypes = async () => {
  const response = await api.get("/enums/mediatypes");
  return response;
};

export const questionTypes = async () => {
  const response = await api.get("/enums/questiontypes");
  return response;
};

export const createCampaign = async (payload) => {
  try {
    const response = await api.post("/versus/campaigns", payload);
    return response;
  } catch (error) {
    console.error("Error creating campaign:", error);
    throw error;
  }
};
export const updateCampaign = async (payload) => {
  try {
    const response = await api.put("/versus/campaigns", payload);
    return response;
  } catch (error) {
    console.error("Error updating campaign:", error);
    throw error;
  }
};

export const launchCampaign = async (payload) => {
  try {
    const response = await api.post("/versus/launchCampaign", payload);
    return response;
  } catch (error) {
    console.error("Error launching campaign:", error);
    throw error;
  }
};

export const getMultiMediaCampaigns = async (params) => {
  const response = await api.get("/versus/mmcampaigns", {
    params,
  });
  return response;
};

export const getClientSettings = async () => {
  const response = await api.get("/versus/clientsettingsrequest");
  return response;
};

export const getVersusCredits = async (clientRef) => {
  const response = await api.get("/versus/credits", {
    params: {
      clientRef: clientRef,
    },
  });
  return response;
};

export const getSubscriptions = async () => {
  const response = await api.get("/versus/subscriptions");
  return response;
};

export const createMultiMediaCampaign = async (payload) => {
  try {
    const response = await api.post("/versus/mmcampaigns", payload);
    return response;
  } catch (error) {
    console.error("Error creating campaign:", error);
    throw error;
  }
};

export const createQuestion = async (payload) => {
  try {
    const response = await api.post("/versus/questions", payload);
    return response;
  } catch (error) {
    console.error("Error creating question:", error);
    throw error;
  }
};

export const updateQuestion = async (payload) => {
  try {
    const response = await api.put("/versus/questions", payload);
    return response;
  } catch (error) {
    console.error("Error creating question:", error);
    throw error;
  }
};

export const deleteQuestion = async (payload) => {
  try {
    const response = await api.delete("/versus/questions", { data: payload });
    return response;
  } catch (error) {
    console.error("Error deleting question:", error);
    throw error;
  }
};

export const getQuestions = async (campaignRef) => {
  const params = campaignRef ? { campaignRef } : {};
  const response = await api.get("/versus/questions", { params });
  return response;
};

export const getSurveyQuestionsAndRespondents = async (campaignsRefs) => {
  const payload = {
    campaignsRefs,
  };

  const response = await api.post(
    "/versus/surveysquestionsandrespondents",
    payload
  );

  return response;
};

export const getTeamMembers = async (clientRef, page = 1, size = 10) => {
  const params = { clientRef, page, size };

  const response = await api.get("/versus/teams", { params });
  return response;
};

export const createDepositCheckoutForPayStack = async (payload) => {
  try {
    const response = await api.post(
      "/versus/paystackcreatedepositcheckout",
      payload
    );
    return response;
  } catch (error) {
    console.error("Error creating deposit checkout:", error);
    throw error;
  }
};

export const createDepositCheckoutForStripe = async (payload) => {
  try {
    const response = await api.post(
      "/versus/stripecreatedepositcheckout",
      payload
    );
    return response;
  } catch (error) {
    console.error("Error creating deposit checkout:", error);
    throw error;
  }
};

export const createSubscriptionPlan = async (payload) => {
  try {
    const response = await api.post("/versus/subscriptionPlan", payload);
    return response;
  } catch (error) {
    console.error("Error creating subscription plan:", error);
    throw error;
  }
};

export const fetchOffBoardClient = async (payload) => {
  try {
    const response = await api.post("/versus/offboardClient", payload);
    return response;
  } catch (error) {
    console.error("Error fetching client:", error);
    throw error;
  }
};

export const createOnboardClient = async (payload) => {
  try {
    const response = await api.post("/versus/onboardClient", payload);
    return response;
  } catch (error) {
    console.error("Error Onboarding Client:", error);
    throw error;
  }
};

export const deleteDraftSurvey = async (payload) => {
  try {
    const response = await api.post("/versus/deletedraftsurvey", payload);
    return response;
  } catch (error) {
    console.error("Error deleting draft survey:", error);
    throw error;
  }
};

export const fetchCampaignData = async (clientRef, campaignRef) => {
  const response = await api.get(
    `/versus/campaign?clientRef=${clientRef}&campaignRef=${campaignRef}`
  );

  return response;
};

export const toggleSurveyStatus = async ({
  clientRef,
  campaignRef,
  mediaType,
}) => {
  const response = await api.post("/versus/togglesurveystatus", {
    clientRef,
    campaignRef,
    mediaType,
  });

  return response;
};

export const fetchTotalFilteredSurveyRespondents = async (payload) => {
  return api.post("/versus/totalfilteredsurveyrespondents", payload);
};

export const fetchTotalSurveyRespondents = async (campaignRef) => {
  const response = await api.get(
    `/versus/totalsurveyrespondent?campaignRef=${campaignRef}`
  );
  return response;
};

export const pauseCampaign = async (campaignRef) => {
  const response = await api.post("/versus/pauseCampaign", {
    campaignRef,
  });

  return response;
};

export const getSurveyOptions = async (payload) => {
  const response = await api.post("/versus/options", payload);
  return response;
};

export const getTotalSurveyQuestions = async ({ clientRef, campaignRef }) => {
  const response = await api.post("/versus/totalsurveyquestions", {
    clientRef,
    campaignRef,
  });

  return response;
};

export const createStripeSubscriptionCheckout = async ({
  clientRef,
  clientEmail,
  subscriptionPlanRef,
  interval,
  successPath,
  cancelPath,
  onboardingToken,
}) => {
  const response = await api.post("/versus/stripecreatesubscriptioncheckout", {
    clientRef,
    clientEmail,
    subscriptionPlanRef,
    interval,
    successPath,
    cancelPath,
    onboardingToken,
  });

  return response;
};

export const stopCampaign = async ({ campaignRef, clientRef }) => {
  const response = await api.post("/versus/stopCampaign", {
    campaignRef,
    clientRef,
  });

  return response;
};

export const reorderQuestions = async (payload) => {
  const response = await api.post("/versus/questionsreorder", payload);

  return response;
};

export const updateTeam = async (payload) => {
  const response = await api.post("/versus/teamcanedit", payload);
  return response;
};

export const removeTeamMember = async (payload) => {
  const response = await api.post("/versus/teamremove", payload);
  return response;
};

export const inviteNewTeamMember = async (
  newTeamMemberEmail,
  email,
  canEdit = false
) => {
  const response = await api.post("/versus/teaminvite", {
    email,
    newTeamMemberEmail,
    canEdit,
  });

  return response;
};

export const getResponses = async ({ questionRef, campaignRef }) => {
  return api.get("/versus/responses", {
    params: {
      questionRef,
      campaignRef,
    },
  });
};

export const duplicateQuestion = async (payload) => {
  const response = await api.post("/versus/questionsduplicate", payload);
  return response;
};

export const fetchMMCampaign = async (campaignRef) => {
  const response = await api.get("/versus/mmcampaigns", {
    params: {
      campaignRef,
    },
  });

  return response;
};

export const fetchTotalMMResponses = async (clientRef) => {
  const response = await api.post("/versus/mmtotalresponses", {
    clientRef,
  });

  return response;
};

export const fetchMMResponses = async ({
  campaignRef,
  status,
  page = 1,
  size = 9,
}) => {
  const response = await api.get("/versus/mmrequestresponses", {
    params: {
      campaignRef,
      status,
      page,
      size,
    },
  });

  return response;
};

export const fetchMMTotalRequestRespondents = async (campaignRef) => {
  const response = await api.get("/versus/mmtotalrequestrespondents", {
    params: {
      campaignRef,
    },
  });

  return response;
};

export const approveRequestResponse = async (responseRef) => {
  const response = await api.post("/versus/approverequestresponse", {
    responseRef,
  });

  return response;
};

export const downloadRequestResponse = async (responseRef) => {
  const response = await api.post("/versus/downloadrequestresponse", {
    responseRef,
  });

  return response;
};

export const rejectRequestResponse = async (
  responseRef,
  reasonForRejection,
  optional_message
) => {
  const response = await api.post("/versus/rejectrequestresponse", {
    responseRef,
    reasonForRejection,
    optional_message,
  });

  return response;
};

export const shareRequestResponses = async (responseRefs, emails) => {
  const response = await api.post("/versus/sharerequestresponses", {
    responseRefs,
    emails,
  });

  return response;
};

export const generateSurveyReport = async ({
  clientRef,
  campaignRef,
  age,
  gender,
  tribe,
  educationLevel,
  religion,
  relationshipStatus,
  employmentStatus,
  childrenInHousehold,
  personalEarningsMonthly,
  householdEarningsMonthly,
  personsInHousehold,
  childrenUnder18,
  states,
  format = "pdf",
}) => {
  const response = await api.post(
    "/versus/surveyreport",
    {
      clientRef,
      campaignRef,
      age,
      gender,
      tribe,
      educationLevel,
      religion,
      relationshipStatus,
      employmentStatus,
      childrenInHousehold,
      personalEarningsMonthly,
      householdEarningsMonthly,
      personsInHousehold,
      childrenUnder18,
      states,
      format,
    },
    {
      responseType: format === "json" ? "json" : "blob",
    }
  );

  return response;
};

export const getTotalEstimatedFilteredSurveyRespondents = async ({
  clientRef,
  age,
  gender,
  lgaIds,
  interestIds,
}) => {
  const response = await api.post(
    "/versus/totalestimatedfilteredsurveyrespondents",
    {
      clientRef,
      age: age?.map(Number),
      gender: gender?.map(Number),
      lgaIds: lgaIds?.map(Number),
      interestIds: interestIds?.map(Number),
    }
  );

  return response;
};
